import React from "react";
import { Link } from "react-router-dom";
import SVGIcons from "../../../assets/images/icons/svgIcons";
import "./terms.scss"
import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";


const Disclaimer = () => {
    ScrollToTopOnMount();

    return (
        <div className="page-main-wrapper privacy-main-wrapper f-wrp">
            <div className="container">
                <div className="breadcrumb f-wrp">
                    <Link to={'/'}> Home &nbsp;&nbsp;<SVGIcons.RightChevronIcon /></Link>&nbsp;
                    <p>Disclaimer</p>
                </div>
                <div className="TC-policy-wrp f-wrp">
                    <h1 className="main-header">Disclaimer</h1>
                    <br />
                    <br />
                    <p>Effective Date: April 17, 2025</p>
                    <br />
                    <p>Welcome to Propshop Real Estate LLC. By accessing and using <a style={{ color: 'inherit' }} href="https://propshop.ai">(https://propshop.ai)</a>, you agree to the terms set out in this disclaimer. Please read it carefully.</p>
                    <br />
                    <p>1. Informational Use Only</p>
                    <br />
                    <p>All content on this website is provided for general informational purposes only. While we strive to provide accurate and up-to-date information about Dubai’s real estate market, including off-plan and ready property listings, project details, and educational content, nothing on this website constitutes legal, financial, or investment advice.</p>
                    <br />
                    <p>2. Accuracy of Listings</p>
                    <br />
                    <p>Although we make every effort to ensure that property listings, pricing, availability, and descriptions are accurate and current, such information is subject to change without notice. Propshop Real Estate LLC does not guarantee the completeness, accuracy, or timeliness of any listing or information presented on this site.</p>
                    <br />
                    <p>3. No Financial Guarantees</p>
                    <br />
                    <p>Any mention of ROI, rental yields, or investment performance is intended as a general guide only and does not guarantee future outcomes. You should always conduct your own research or consult a qualified professional before making real estate decisions based on information from this site.</p>
                    <br />
                    <p>4. Independent Advice</p>
                    <br />
                    <p>Propshop Real Estate LLC is not responsible for any decisions you make based on the content provided on this website. We strongly recommend seeking independent legal, financial, or real estate advice tailored to your personal situation before taking action.</p>
                    <br />
                    <p>5. No Developer Affiliations (Unless Stated)</p>
                    <br />
                    <p>Propshop Real Estate LLC is an independent real estate brokerage. We are not officially affiliated with or endorsed by any developer unless explicitly stated on our website. Use of our site does not create any formal partnership or agency relationship with any developer or third party unless otherwise specified.</p>
                    <br />
                    <p>6. Third-Party Tools and Content</p>
                    <br />
                    <p>Our website may incorporate third-party services or tools, such as:</p>
                    <br />
                    <ul>
                        <li>Embedded maps (e.g., Google Maps)</li>
                        <li>Mortgage calculators</li>
                        <li>Market data or content from third-party sources</li>
                        <li>We do not guarantee the accuracy, reliability, or availability of these tools and are not liable for their use.</li>
                    </ul>
                    <br />
                    <p>7. Regional Focus</p>
                    <br />
                    <p>This website is primarily intended for users interested in real estate within the United Arab Emirates, particularly the Dubai property market. Content and services may not be applicable to users in other jurisdictions.</p>
                    <br />
                    <p>8. Changes to This Disclaimer</p>
                    <br />
                    <p>We reserve the right to modify or update this disclaimer at any time without prior notice. Continued use of the site constitutes acceptance of the most recent version.</p>
                    <br />
                    <h4>Contact</h4>
                    <br />
                    <p>For any questions regarding this disclaimer, please contact us at:</p>
                    <p><a style={{ color: 'inherit' }} href="mailto:admin@propshop.ai">📧 admin@propshop.ai</a></p>
                </div>
            </div>
        </div>
    );
};

export default Disclaimer;
